import { MeetingProvider } from '@providers/MeetingProvider';
import { useVoiceFocus } from '@providers/VoiceFocusProvider';
import type { AudioInputDevice, Device } from 'amazon-chime-sdk-js';
import { VoiceFocusTransformDevice } from 'amazon-chime-sdk-js';
import type { FC, PropsWithChildren } from 'react';

const MeetingProviderWithDeviceReplacement: FC<PropsWithChildren> = ({
  children,
}) => {
  const { addVoiceFocus } = useVoiceFocus();

  const onDeviceReplacement = (
    nextDevice: string,
    currentDevice?: AudioInputDevice,
  ): Promise<Device | VoiceFocusTransformDevice> => {
    if (currentDevice instanceof VoiceFocusTransformDevice) {
      return addVoiceFocus(nextDevice);
    }
    return Promise.resolve(nextDevice);
  };

  const meetingConfigValue = {
    onDeviceReplacement,
  };

  return <MeetingProvider {...meetingConfigValue}>{children}</MeetingProvider>;
};

export default MeetingProviderWithDeviceReplacement;
